import { render, staticRenderFns } from "./logisPaidOrderListV0.vue?vue&type=template&id=793fc429&scoped=true"
import script from "./logisPaidOrderListV0.vue?vue&type=script&lang=js"
export * from "./logisPaidOrderListV0.vue?vue&type=script&lang=js"
import style0 from "./logisPaidOrderListV0.vue?vue&type=style&index=0&id=793fc429&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793fc429",
  null
  
)

export default component.exports